export default function Text({ children = "" }) {
  return (
    <p
      dangerouslySetInnerHTML={{
        __html: children.replace(/(?:\r\n|\r|\n)/g, "<br />"),
      }}
    />
  );
}
